import script from "./max_title_text.vue?vue&type=script&setup=true&lang=js"
export * from "./max_title_text.vue?vue&type=script&setup=true&lang=js"

import "./max_title_text.vue?vue&type=style&index=0&id=03ddfdca&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03ddfdca"]])

export default __exports__